<template>
    <Breadcrumbs
        main="Résultats du sondage"
        mains="Résultats du sondage"
        title="Accueil"
    />
    <div class="container-fluid">
        <div class="row">
            <SurveyResults />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const SurveyResults = defineAsyncComponent(
    () => import('@/components/theme/survey/SurveyResults.vue'),
);
</script>